// extracted by mini-css-extract-plugin
module.exports = {"FormButtons":"styles_FormButtons__1C1yq"};